import type { JSX } from 'react';
import { SoundList } from '../components/SoundLink';
import { soundRefsFromParams } from '../lib/sounds';
import { describeParams } from './params';

/**
 * `describeParams` as React: a sound search names every sound it ran on
 * (from the sound catalogue) instead of the first raw id. Not linked — it is
 * rendered inside the button that loads the search.
 */
export function ParamsLabel({ params }: { params: Record<string, unknown> }): JSX.Element {
  const sounds = soundRefsFromParams(params);
  if (sounds.length === 0) return <>{describeParams(params)}</>;
  return (
    <>
      {sounds.length === 1 ? 'Sound: ' : 'Sounds: '}
      <SoundList sounds={sounds} linked={false} max={3} />
    </>
  );
}
